import { EnumLanguage } from "../EnumLanguage";

export const UXCookies = {
	cookiesMessage: {
		[EnumLanguage.en]:
			'We use cookies. When visiting the website of the Federal State Budgetary Cultural Institution "All-Russian Museum Association "State Tretyakov Gallery" you agree that we process your personal data using metric programs.',
		[EnumLanguage.ru]:
			"Мы используем cookie. Во время посещения сайта Федерального государственного бюджетного учреждения культуры «Всероссийское музейное объединение «Государственная Третьяковская галерея» вы соглашаетесь с тем, что мы обрабатываем ваши персональные данные с использованием метрических программ.",
		[EnumLanguage.cn]:
			'我们使用 cookie。在访问联邦国家预算文化机构 "全俄博物馆协会"（"国立特列季亚科夫画廊"）的网站时，您同意我们使用度量程序处理您的个人数据。'
	},
	cookiesMessageLink: {
		[EnumLanguage.en]: "Read More",
		[EnumLanguage.ru]: "Подробнее",
		[EnumLanguage.cn]: "更多信息"
	},
	cookiesAcceptButton: {
		[EnumLanguage.en]: "Accept",
		[EnumLanguage.ru]: "Принять",
		[EnumLanguage.cn]: "接受"
	}
};
